import React from 'react'
import {Button as AntButton} from 'antd'
import {ButtonProps} from './props'

export const Button: React.FC<ButtonProps> = (props) => <AntButton {...props} />
